var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFuCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.83,
    height: 8.926,
    viewBox: "0 0 8.83 8.926",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "cross",
    d: "M5.224,4.6,8.662,1.123a.582.582,0,0,0,0-.818.567.567,0,0,0-.809,0L4.415,3.781.977.305a.567.567,0,0,0-.809,0,.582.582,0,0,0,0,.818L3.606,4.6.168,8.075a.582.582,0,0,0,0,.818.567.567,0,0,0,.809,0L4.415,5.417,7.854,8.892a.567.567,0,0,0,.809,0,.582.582,0,0,0,0-.818Zm0,0",
    transform: "translate(0 -0.136)",
    fill: "#868687"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuCross);
export default __webpack_public_path__ + "static/media/FU_cross.d0ced82e3de0e6dc421bfaa8d63d8e57.svg";
export { ForwardRef as ReactComponent };